<template>
    <div ref="nav">
        <div class="margin">
            大连佳音科技有限公司是“玖月琴侣HD”的研发生产方，是其知识产权、软件著作权、商标及专利权的所有者。近日，我司在闲鱼等APP平台发现不法商家及个人未经我司授权，批量发布和违规售卖未经我司认证授权的设备，并在其宣传过程中滥用我司品牌标识及广告语，涉嫌误导消费者的虚假销售行为，扰乱我司产品的市场定位和销售规定，上述行为已经损害了我司的社会信誉与经济利益，构成对我司合法权利的侵犯。
            </br>对此，我司郑重声明如下：
            </br></br>
            一、玖月琴侣HD仅在售“玖月琴侣课后陪练服务”和“玖月琴侣智能曲谱服务”两款产品。
            </br></br>
            二、玖月琴侣HD提供的相关产品仅可从如下渠道购买：</br>
            1.玖月琴侣HD官方总部；</br>
            2.玖月琴侣HD官方授权的地方代理商、合作机构。</br>
            </br>
            三、纠错大师（JOY MASTER)仅为“玖月琴侣课后陪练服务”配备的辅助设备，不作单独售卖。从非法渠道单独购买此设备，我司不提供相一切售后服务和用户权益。</br>
            正式警告涉及侵犯我司合法权利的商家和个人，立刻下架违规产品，停止销售行为。对于仍然非法销售的商家及个人，一切后果，自行承担，并且我司保留采取司法措施权利，以及追偿由此引发的任何损害赔偿及相关费用的权利。</br>
            </br>
            特此声明！
        </div>
        <div class="margin" style="text-align: right;margin-bottom:40px;">
            大连佳音科技有限公司</br>
            2021年12月10日
        </div>
    </div>
</template>
<script>
export default {
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
.margin {
    width: 88%;
    margin: 0 auto;
    margin-top: 24px;
}

.color {}
</style>



// WEBPACK FOOTER //
// src/components/DeclarationLetter.vue